import React, { SVGProps } from 'react';

export const ShareWithArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      {...props}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M19.354 6.564h-4.7c-3.655 0-6.628 3.096-6.628 6.9v2.664h1.8v-2.664c0-2.813 2.166-5.1 4.828-5.1h4.7l-3.492 3.492 1.272 1.272L22.8 7.464 17.134 1.8l-1.272 1.272 3.492 3.492Z"
      />
      <path
        fill="currentColor"
        d="M1.8 13.493c0-7.785.643-9.514 6.228-9.835v1.776C3.696 5.636 3.6 6.803 3.6 13.493c0 4.177.038 6.2 1.12 7.18.839.715 2.303.878 4.862.915.425.004.88.005 1.368.005v.005h.75c7.418 0 8.045-.118 8.096-5.998h1.793c-.121 7.04-1.428 7.799-9.89 7.799-.458 0-.896-.003-1.314-.008-3.614-.021-5.723-.268-6.946-1.407-1.402-1.24-1.64-3.532-1.64-7.735h.003l-.002-.756Z"
      />
    </svg>
  );
};
